/**
 * @generated SignedSource<<d2e60b255cc8952981df0c506b6f98de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateNewUserOnAccountInput = {
  avatarIndex: number;
  displayName: string;
  username: string;
};
export type CreateNewPlayerFormMutation$variables = {
  input: CreateNewUserOnAccountInput;
};
export type CreateNewPlayerFormMutation$data = {
  readonly createNewUserOnAccount: {
    readonly id: string;
    readonly username: string;
    readonly usernameID: string;
  } | null;
};
export type CreateNewPlayerFormMutation = {
  response: CreateNewPlayerFormMutation$data;
  variables: CreateNewPlayerFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "createNewUserOnAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usernameID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateNewPlayerFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateNewPlayerFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77e9e07514b4094a0939237a40ba0242",
    "id": null,
    "metadata": {},
    "name": "CreateNewPlayerFormMutation",
    "operationKind": "mutation",
    "text": "mutation CreateNewPlayerFormMutation(\n  $input: CreateNewUserOnAccountInput!\n) {\n  createNewUserOnAccount(input: $input) {\n    id\n    username\n    usernameID\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aca1d1fd2adb438a134df61a9480fec";

export default node;
